'use strict';

export const DOM = {
	section: 'section.blog__posts',
	form: 'form.blog__controls',
	postsContainer: '.posts__container',

	// Pagination
	pagination: '.pagination',
	paginationCenter: '.pagination__center',
	paginationWrapper: '.posts__pagination',
	paginationSlider: '.pagination__slider',
};
